/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

const baseUrl = 'https://pacientes-alviarmani.tecsolutions.com.ar:8010';

export const environment = {
  production: false,
  projectName: 'Alviarmani',
  baseUrl,
  apiUrl: `${baseUrl}/v1`,
  mercadoPagoPublicKey: 'TEST-d777681a-faaf-459f-847a-b6419d3b8f9b',
  xdebug: false,
  allowLangSelector: true,
  strSecure: 'Alviarmani',
  version: 1,
  versionFile: 'version.json',
  timeCheckVersion: 60000,
  entorno: 'test',
  title: 'Alviarmani: A New Era in Hair Transplants',
};
